import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { ERRORS, messages, TABLE_QUERY_KEYS } from 'app/config/constants';
import { queryClient } from 'app/app';
import { CaseBuildingPlotModel, PlotBeingCreatedModel } from '../model/case-building-plot-form.model';
import {
  deletePlotBeingCreated,
  fetchAllDkpLocations,
  fetchAllPlotBeingCreated,
  fetchCaseBuildingPlot,
  fetchPlotBeingCreated,
  saveCaseBuildingPlot,
  savePlotBeingCreated
} from 'app/edozvola/cases/case-building-plot/service/case-building-plot-form.service';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import success = toast.success;

export const saveCaseBuildingPlotQuery = (idCase: string) => {
  return useMutation({
    mutationFn: (values: CaseBuildingPlotModel) => {
      return saveCaseBuildingPlot(idCase, values);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: ['case-building-plot'] });
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.PLOT_BEING_CERATED_TABLE] });
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
};

export const fetchCaseBuildingPlotQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['case-building-plot'],
    queryFn: () => fetchCaseBuildingPlot(idCase),
  });
};

export const fetchDkpLocationsQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['dkp-locations-all'],
    queryFn: () => fetchAllDkpLocations(idCase),
    enabled: !!idCase
  });
};

export const fetchPlotBeingCreatedQuery = (idPlotBeingCreated: string) => {
  return useQuery({
    queryKey: ['plot-being-created', {idPlotBeingCreated: idPlotBeingCreated}],
    queryFn: () => fetchPlotBeingCreated(idPlotBeingCreated),
    enabled: !!idPlotBeingCreated
  });
};

export const savePlotBeingCreatedMutation = (idCase: string, onSuccess: any) => {
  return useMutation({
    mutationFn: (values: PlotBeingCreatedModel) => {
      return savePlotBeingCreated(idCase, values);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({queryKey: [TABLE_QUERY_KEYS.PLOT_BEING_CERATED_TABLE]})
      onSuccess()
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
}

export const fetchAllPlotBeingCreatedQuery = (pagination: PaginationState, idCase: string) => {
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.PLOT_BEING_CERATED_TABLE, { idCase: idCase, pagination: { ...pagination } }],
    queryFn: ({ signal }) => fetchAllPlotBeingCreated(idCase, pagination.page, pagination.size, pagination.column, pagination.direction),
  });
};

export const deletePlotBeingCreatedMutation = () => {
  return useMutation({
    mutationFn: (idPlotBeingCreated: string) => {
      return deletePlotBeingCreated(idPlotBeingCreated);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({queryKey: [TABLE_QUERY_KEYS.PLOT_BEING_CERATED_TABLE]})
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
}
